import * as types from './types'

const data = {
	loading: false,
	success: false,
	failed: false,
	data: null,
}

const initialAccident = {
	content: [],
	pageable: null,
	totalPages: 0,
	totalElements: 0,
	last: false,
	number: 0,
	sort: null,
	size: 0,
	first: false,
	numberOfElements: 0,
	empty: false,
}

const initialState = {
	isLoading: false,
	isSuccess: false,
	isLoadingSend: false,
	isSuccessSend: false,
	error: null,
	accidents: initialAccident,
	selectedAccidents: [],
	reportXml: {},
	accident: null,

	person: data,
	setSeverity: data,
	investigationReport: data,
	getFillingAct: data,
	setFillingAct: data,
	getActRepresentative: data,
	setActRepresentative: data,
}

export const reducer = (state = initialState, actions) => {
	const { type, payload } = actions
	switch (type) {
		case types.TOGGLE_LOADING:
			return { ...state, isLoading: payload }
		case types.TOGGLE_SUCCESS:
			return { ...state, isSuccess: payload }
		case types.TOGGLE_LOADING_SEND:
			return { ...state, isLoadingSend: payload }
		case types.TOGGLE_SUCCESS_SEND:
			return { ...state, isSuccessSend: payload }

		case types.TOGGLE_ERROR:
			return { ...state, accidents: initialAccident, error: payload }
		case types.SET_ACCIDENTS:
			return {
				...state,
				accidents: payload,
			}
		case types.SET_REPORT_XML:
			return {
				...state,
				reportXml: payload,
			}
		case types.SET_ACCIDENT:
			return {
				...state,
				accident: payload,
			}
		case types.RESET_REPORT_XML:
			return {
				...state,
				reportXml: {},
			}

		case types.GET_PERSON:
			return { ...state, person: { ...data, loading: true } }

		case types.GET_PERSON_DONE:
			return { ...state, person: { ...data, data: payload, success: true } }

		case types.GET_PERSON_FAIL:
			return { ...state, person: { ...data, failed: true } }

		case types.SEND_SEVERITY:
		case types.SEND_SEVERITY_XML:
			return { ...state, setSeverity: { ...data, loading: true } }

		case types.SEND_SEVERITY_DONE:
		case types.SEND_SEVERITY_XML_DONE:
			return { ...state, setSeverity: { ...data, data: payload, success: true } }

		case types.SEND_SEVERITY_FAIL:
		case types.SEND_SEVERITY_XML_FAIL:
			return { ...state, setSeverity: { ...data, failed: true } }

		case types.GET_INVESTIGATION_REPORT:
			return { ...state, investigationReport: { ...data, loading: true } }

		case types.GET_INVESTIGATION_REPORT_DONE:
			return { ...state, investigationReport: { ...data, data: payload, success: true } }

		case types.GET_INVESTIGATION_REPORT_FAIL:
			return { ...state, investigationReport: { ...data, failed: true } }

		case types.GET_FILLING_ACT:
			return { ...state, getFillingAct: { ...data, loading: true } }

		case types.GET_FILLING_ACT_DONE:
			return { ...state, getFillingAct: { ...data, data: payload, success: true } }

		case types.GET_FILLING_ACT_FAIL:
			return { ...state, getFillingAct: { ...data, failed: true } }

		case types.SEND_FILLING_ACT:
		case types.SEND_FILLING_ACT_XML:
			return { ...state, setFillingAct: { ...data, loading: true } }

		case types.SEND_FILLING_ACT_DONE:
		case types.SEND_FILLING_ACT_XML_DONE:
			return { ...state, setFillingAct: { ...data, data: payload, success: true } }

		case types.SEND_FILLING_ACT_FAIL:
		case types.SEND_FILLING_ACT_XML_FAIL:
			return { ...state, setFillingAct: { ...data, failed: true } }

		case types.GET_ACT_REPRESENTATIVE:
			return { ...state, getActRepresentative: { ...data, loading: true } }

		case types.GET_ACT_REPRESENTATIVE_DONE:
			return { ...state, getActRepresentative: { ...data, data: payload, success: true } }

		case types.GET_ACT_REPRESENTATIVE_FAIL:
			return { ...state, getActRepresentative: { ...data, failed: true } }

		case types.SEND_ACT_REPRESENTATIVE:
		case types.SEND_ACT_REPRESENTATIVE_XML:
			return { ...state, setActRepresentative: { ...data, loading: true } }

		case types.SEND_ACT_REPRESENTATIVE_DONE:
		case types.SEND_ACT_REPRESENTATIVE_XML_DONE:
			return { ...state, setActRepresentative: { ...data, data: payload, success: true } }

		case types.SEND_ACT_REPRESENTATIVE_FAIL:
		case types.SEND_ACT_REPRESENTATIVE_XML_FAIL:
			return { ...state, setActRepresentative: { ...data, failed: true } }

		default:
			return state
	}
}
